module.exports = __webpack_public_path__ + "img/list-layout-active.d7cf1382.svg";